import BlogPostItem, { BlogPostItemProps } from "./LastestNews";

interface ProductExamplesProps {
    data: any[];
    title: string;
    readMoreText: string;
    readMoreLink: string;
}

const ProductExamples: React.FC<ProductExamplesProps> = (props) => {

    return (
        <div className="latest-news2">
            <h2
                className="light bordered"
                dangerouslySetInnerHTML={{ __html: props.title }}
            ></h2>

            <ul id="latest-news-carousel" className="jcarousel-skin-tango blog-style2 list-unstyled">
                {props.data?.map((product: any, index: any) => {
                    // Create a modified product object with the new id format
                    const modifiedProduct = {
                        ...product,
                        id: `${product.title}-${product.id}`,
                    };

                    return (
                        <BlogPostItem
                            key={modifiedProduct.id}
                            {...modifiedProduct}
                            sefUrl={props.readMoreLink + product.category.slug + "/" + product.sef_url}
                            readmore={props.readMoreText}
                        />
                    );
                })}
            </ul>
        </div>
    )
}

export default ProductExamples;